export const TEAM_PAGE_USERS_PAGE_CHANGE = "APP/UI/TEAM_PAGE/USERS_PAGE_CHANGE";
export const TEAM_PAGE_PENDING_USERS_PAGE_CHANGE =
  "APP/UI/TEAM_PAGE/PENDING_USERS_PAGE_CHANGE";
export const TEAM_PAGE_USERS_TABLE_CHANGE =
  "APP/UI/TEAM_PAGE/USERS_TABLE_CHANGE";
export const SWITCH_TEAM = "APP/UI/SWITCH_TEAM";
